var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"subtitle has-text-centered"},[_vm._v("\n    "+_vm._s(_vm.approvedTransactions.length)+" "+_vm._s(_vm.$t("transactions.approved"))+" -\n    "),_c('b-tooltip',{attrs:{"multilined":"","label":"Fat. Bruto / Qtd. Vendas Aprovadas"}},[_vm._v("\n      "+_vm._s(((_vm.$t("transactions.averageTicket")) + " " + (_vm.payments.currencySymbol)))+"\n      "+_vm._s(_vm.formatMoney(
          _vm.approvedTransactions.length
            ? _vm.grossSales / _vm.approvedTransactions.length
            : 0
        ))+"\n    ")])],1),_c('div',{staticClass:"columns has-text-centered is-mobile is-multiline"},[_c('summary-card',{attrs:{"tooltipText":_vm.$t('transactions.grossSalesDescription'),"text":_vm.$t('transactions.grossSales'),"value":_vm.grossSales}}),_c('summary-card',{attrs:{"tooltipText":_vm.$t('transactions.discountsDescription'),"text":_vm.$t('transactions.discounts'),"value":_vm.discounts}}),_c('summary-card',{attrs:{"tooltipText":_vm.$t('transactions.netSalesDescription'),"text":_vm.$t('transactions.netSales'),"value":_vm.netSales}}),_c('summary-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.onlyCacauShowVendings),expression:"!onlyCacauShowVendings"}],attrs:{"tooltipText":_vm.$t('transactions.royaltiesDescription'),"text":_vm.$t('transactions.royalties'),"value":_vm.royalties}}),_c('summary-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.onlyCacauShowVendings),expression:"!onlyCacauShowVendings"}],attrs:{"tooltipText":_vm.$t('transactions.receivableDescription'),"text":_vm.$t('transactions.receivable'),"value":_vm.receivable}}),_c('summary-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.onlyCacauShowVendings),expression:"!onlyCacauShowVendings"}],attrs:{"tooltipText":_vm.$t('transactions.cogsDescription'),"text":_vm.$t('transactions.cogs'),"value":_vm.cogs,"percentage":((_vm.cogs / _vm.grossSales) * 100).toFixed(2)}}),_c('summary-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.onlyCacauShowVendings),expression:"!onlyCacauShowVendings"}],attrs:{"tooltipText":_vm.$t('transactions.marginDescription'),"text":_vm.$t('transactions.margin'),"value":_vm.margin,"percentage":((_vm.margin / _vm.grossSales) * 100).toFixed(2)}})],1),_c('div',{staticClass:"columns has-text-centered is-mobile is-multiline"},[(_vm.buyNowPayLaterValue > 0)?_c('summary-card',{attrs:{"cards":[
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: _vm.$t('transactions.buyNowPayLater'),
          value: _vm.buyNowPayLaterValue,
          percentage: _vm.buyNowPayLaterPercentage
        }
      ],"bigCard":""}}):_vm._e(),_c('summary-card',{attrs:{"cards":[
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: _vm.$t('transactions.pixAndPrepaid'),
          value: _vm.pixAndPrepaidValue,
          percentage: _vm.pixAndPrepaidPercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: _vm.$t('transactions.pix'),
          value: _vm.pixValue,
          percentage: _vm.pixValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: _vm.$t('transactions.prepaid'),
          value: _vm.appPrepaidValue,
          percentage: _vm.appPrepaidValuePercentage
        }
      ],"bigCard":""}}),_c('summary-card',{attrs:{"cards":[
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: _vm.$t('transactions.voucher'),
          value: _vm.voucherValue,
          percentage: _vm.voucherValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: ("" + (_vm.$t('transactions.sodexo'))),
          value: _vm.voucherSodexoValue,
          percentage: _vm.voucherSodexoValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: ("" + (_vm.$t('transactions.alelo'))),
          value: _vm.voucherAleloValue,
          percentage: _vm.voucherAleloValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: ("" + (_vm.$t('transactions.ticket'))),
          value: _vm.voucherTicketValue,
          percentage: _vm.voucherTicketValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: ("" + (_vm.$t('transactions.vr'))),
          value: _vm.voucherVrValue,
          percentage: _vm.voucherVrValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: ("" + (_vm.$t('transactions.verocard'))),
          value: _vm.voucherVerocardValue,
          percentage: _vm.voucherVerocardValuePercentage
        },
        {
          tooltipText: _vm.$t('transactions.relativeToNetSales'),
          text: ("" + (_vm.$t('transactions.ben'))),
          value: _vm.voucherBenValue,
          percentage: _vm.voucherBenValuePercentage
        }
      ],"bigCard":""}}),_c('summary-card',{attrs:{"cards":_vm.tefCreditValue > 0
          ? [
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.credit'),
                value: _vm.creditTotalValue,
                percentage: _vm.creditTotalPercentage
              },
              // {
              //   tooltipText: $t('transactions.relativeToNetSales'),
              //   text: $t('transactions.tefCredit'),
              //   value: tefCreditValue,
              //   percentage: tefCreditValuePercentage,
              // },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.terminalCredit'),
                value: _vm.terminalCreditValue,
                percentage: _vm.terminalCreditValuePercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.appCreditAdyen'),
                value: _vm.appCreditAdyenValue,
                percentage: _vm.appCreditAdyenValuePercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.googlepay')) + " " + (_vm.$t(
                  'transactions.credit'
                )) + " "),
                value: _vm.googlePayCreditValue,
                percentage: _vm.googlePayCreditPercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.applepay')) + " " + (_vm.$t(
                  'transactions.credit'
                )) + " "),
                value: _vm.applePayCreditValue,
                percentage: _vm.applePayCreditValuePercentage
              }
            ]
          : [
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.credit'),
                value: _vm.creditTotalValue,
                percentage: _vm.creditTotalPercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.terminalCredit'),
                value: _vm.terminalCreditValue,
                percentage: _vm.terminalCreditValuePercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.appCreditAdyen'),
                value: _vm.appCreditAdyenValue,
                percentage: _vm.appCreditAdyenValuePercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.googlepay')) + " " + (_vm.$t(
                  'transactions.credit'
                )) + " "),
                value: _vm.googlePayCreditValue,
                percentage: _vm.googlePayCreditPercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.applepay')) + " " + (_vm.$t(
                  'transactions.credit'
                )) + " "),
                value: _vm.applePayCreditValue,
                percentage: _vm.applePayCreditValuePercentage
              }
            ],"bigCard":""}}),_c('summary-card',{attrs:{"cards":_vm.tefDebitValue > 0
          ? [
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.debit'),
                value: _vm.debitTotalValue,
                percentage: _vm.debitTotalPercentage
              },
              // {
              //   tooltipText: $t('transactions.relativeToNetSales'),
              //   text: $t('transactions.tefDebit'),
              //   value: tefDebitValue,
              //   percentage: tefDebitValuePercentage,
              // },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.terminalDebit'),
                value: _vm.terminalDebitValue,
                percentage: _vm.terminalDebitValuePercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.googlepay')) + " " + (_vm.$t(
                  'transactions.debit'
                ))),
                value: _vm.googlePayDebitValue,
                percentage: _vm.googlePayDebitPercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.applepay')) + " " + (_vm.$t(
                  'transactions.debit'
                ))),
                value: _vm.applePayDebitValue,
                percentage: _vm.applePayDebitValuePercentage
              }
            ]
          : [
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.debit'),
                value: _vm.debitTotalValue,
                percentage: _vm.debitTotalPercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: _vm.$t('transactions.terminalDebit'),
                value: _vm.terminalDebitValue,
                percentage: _vm.terminalDebitValuePercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.googlepay')) + " " + (_vm.$t(
                  'transactions.debit'
                ))),
                value: _vm.googlePayDebitValue,
                percentage: _vm.googlePayDebitPercentage
              },
              {
                tooltipText: _vm.$t('transactions.relativeToNetSales'),
                text: ((_vm.$t('transactions.applepay')) + " " + (_vm.$t(
                  'transactions.debit'
                ))),
                value: _vm.applePayDebitValue,
                percentage: _vm.applePayDebitValuePercentage
              }
            ],"bigCard":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }